/**
 * RHF’s `dirtyFields` is nested (including field arrays). A shallow
 * `Object.keys(dirtyFields).length` can miss or under-count nested / array
 * changes. Walk the tree to see if anything is actually dirty.
 */
export function isAnyDirtyInFieldTree(value: unknown): boolean {
  if (value === true) {
    return true;
  }
  if (value === false || value == null) {
    return false;
  }
  if (Array.isArray(value)) {
    return value.some((item) => isAnyDirtyInFieldTree(item));
  }
  if (typeof value === "object") {
    return Object.values(value as Record<string, unknown>).some((child) =>
      isAnyDirtyInFieldTree(child),
    );
  }
  return false;
}
